import { Inject, Injectable } from '@angular/core';
import mixpanel, { Dict } from 'mixpanel-browser';
import { UserService } from '@app/services/user/user.service';
import { NavigationEnd, Router } from '@angular/router';
import { APP_CONFIG, AppConfiguration } from '@app/infrastructure/auth/app-configuration';

export enum AnalyticsEvents {
	signIn = 'Sign In',
	pageVisit = 'Page Visit',
	sessionOver = 'Session Over',
	click = 'Click',
}

export enum AnalyticsEventProperties {
	actionName = 'Action Name',
	componentName = 'Component Name',
}

export enum AnalyticStatus {
	timeOut = 'Time out',
	logout = 'Logout',
	success = 'Success',
	failed = 'Failed',
}

@Injectable({
	providedIn: 'root',
})
export class MixpanelService {
	constructor(
		private userService: UserService,
		private router: Router,
		@Inject(APP_CONFIG) private appConfig: AppConfiguration,
	) {}

	private initialized: boolean = false;
	private isSignedIn: boolean = false;
	private metadata: { [key: string]: any } = {};
	private lastNavigationUrl: string;

	public init(): void {
		if (this.initialized) {
			return;
		}
		const userEmailProvider = this.userService.userEmail.split('@')[1];
		if (this.appConfig.mixpanel) {
			this.initialized = true;
			mixpanel.init(this.appConfig.mixpanel, { ip: false });
			mixpanel.identify(this.userService.userId);
			this.metadata = {
				'Organization Name': this.userService.userCompany,
				'User ID': this.userService.userId,
				'User Role': this.userService.userRole,
				'Is Zesty Employee': userEmailProvider.includes('zesty') || userEmailProvider.includes('cloudvisor'),
			};
			window.mixpanel = mixpanel; // to support hotjar/mixpanel integration
		}

		this.router.events.subscribe((event) => {
			const url = new URL(location.href);
			if (!this.isSignedIn && url.searchParams.get('code') && url.searchParams.get('state')) {
				this.isSignedIn = true;
				this.track(AnalyticsEvents.signIn, { Status: AnalyticStatus.success });
			}
			if (event instanceof NavigationEnd && this.lastNavigationUrl !== event.urlAfterRedirects) {
				this.lastNavigationUrl = event.urlAfterRedirects;
				if (this.initialized) {
					mixpanel.track_pageview(this.metadata);
				}
			}
		});
	}

	public track(eventName: AnalyticsEvents, trackingProps: Dict = {}): void {
		this.initialized
			? mixpanel.track(eventName, { ...this.metadata, ...trackingProps })
			: console.log({
					eventName,
					trackingProps: {
						...this.metadata,
						...trackingProps,
					},
			  });
		if (eventName === AnalyticsEvents.sessionOver) {
			this.initialized ? mixpanel.reset() : console.log('mixpanel reset');
		}
	}

	public reset(): void {
		this.initialized ? mixpanel.reset() : console.log('mixpanel reset');
	}
}
